import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Avatar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Collaborator {
    Id: string;
    Contact__r: {
        Name: string;
        Profile_Picture_URL__c?: string;
        Batch__c?: string;
    };
}

interface Props {
    open: boolean;
    onClose: () => void;
    collaborators: Collaborator[];
}

const CollaboratorsModal: React.FC<Props> = ({ open, onClose, collaborators }) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth 
        PaperProps={{
            sx: { borderRadius: '12px' }
        }}
    >
        <DialogTitle sx={{fontSize:"16px",fontWeight:"500"}}>
            Collaborators
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{ position: 'absolute', right: 8, top: 8 }}
            >
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            {collaborators.length === 0 ? (
                <Typography>No collaborators found.</Typography>
            ) : (
                collaborators.map((collab) => (
                    <Box key={collab.Id} display="flex" alignItems="center" mb={2} sx={{ background: "#F6F8FB",padding:"10px",borderRadius:"8px" }}>
                        <Avatar
                            src={collab.Contact__r.Profile_Picture_URL__c}
                            alt={collab.Contact__r.Name}
                            sx={{ mr: 2 }}
                        />
                        <Box>
                            <Typography fontWeight={500}>{collab.Contact__r.Name}</Typography>
                            {collab.Contact__r.Batch__c && (
                                <Typography variant="body2" color="textSecondary">
                                    Batch - {collab.Contact__r.Batch__c}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                ))
            )}
        </DialogContent>
    </Dialog>
);

export default CollaboratorsModal; 